import { HttpService } from "@/src/common/axiosInstance"
import { ExternalHTTP as HTTP } from "@/src/common/data-layer"
import {
  camelCaseObjectProperty,
  snakeCaseObjectProperty
} from "@/src/common/utils"
import { Axios, AxiosRequestTransformer, AxiosResponseTransformer } from "axios"

export class ExternalHTTP extends HTTP {
  constructor() {
    super(new HttpService().ax)

    this.axios.defaults.transformResponse = [
      ...(this.axios.defaults
        .transformResponse as Array<AxiosResponseTransformer>),
      camelCaseObjectProperty
    ]

    this.axios.defaults.transformRequest = [
      snakeCaseObjectProperty,
      ...(this.axios.defaults
        .transformRequest as Array<AxiosRequestTransformer>)
    ]
  }

  public getAxios(): Axios {
    return this.axios
  }
}

const ExternalHTTPInstance = new ExternalHTTP()
export default ExternalHTTPInstance
